var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPetFriendlySolid = function SvgPetFriendlySolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.598 3.27a5.75 5.75 0 0 0-4.622 9.837l7.496 7.425a.749.749 0 0 0 .182.133h.001c.137.071.285.096.427.08a.747.747 0 0 0 .46-.218c.215-.218.431-.436.65-.652a.75.75 0 0 0 .03-1.034 5.75 5.75 0 0 1 7.35-8.704.75.75 0 0 0 1.148-.56 5.769 5.769 0 0 0-.52-3.015 5.749 5.749 0 0 0-9.196-1.689 5.75 5.75 0 0 0-3.406-1.602Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.518 10.749a.75.75 0 0 0 0 1.5h.01a.75.75 0 1 0 0-1.5h-.01ZM14.5 11.749a.75.75 0 0 0 0 1.5h.01a.75.75 0 0 0 0-1.5h-.01ZM20.5 11.749a.75.75 0 0 0 0 1.5h.01a.75.75 0 0 0 0-1.5h-.01Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 13.75a3.751 3.751 0 0 0-3.751 3.752c0 .966.784 1.75 1.75 1.75h4.002a1.75 1.75 0 0 0 1.75-1.75 3.751 3.751 0 0 0-3.75-3.751Zm-2.251 3.752a2.251 2.251 0 0 1 4.502 0 .25.25 0 0 1-.25.25H15.5a.25.25 0 0 1-.25-.25Z",
    fill: "currentColor"
  })));
};
export default SvgPetFriendlySolid;